    ele.apps = ele.apps || {};
    ele.apps.SelectorApp = new Selector.View.AppView;
});